import { dateWithoutTimezone } from "../utilities/datetime-utility"

export default {
    use() {
        Date.prototype.toJSON = function () {
            return dateWithoutTimezone(this)
        }
    },
}
